/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';

/** Тип одноразовой ошибки входа. */
export type AuthError = 'server' | 'locked' | 'forbidden';

@Injectable({
  providedIn: 'root'
})
export class AuthStateService {

  private readonly error$ = new Subject<AuthError>();

  /**
   * Поток одноразовых ошибок входа — SignInComponent показывает по нему тост.
   * Subject (не BehaviorSubject): без реплея, тост только на реальную ошибку.
   */
  get errors(): Observable<AuthError> {
    return this.error$.asObservable();
  }

  public emitError(error: AuthError): void {
    this.error$.next(error);
  }

}
